var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay__inner"},[_c('div',{staticClass:"overlay__content"},[_c('span',{staticClass:"spinner"})])])])
}]

export { render, staticRenderFns }